import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import defaultCardImage from "../../../assets/images/home-page/howItWork/default-card-img.svg";
import { StyledButton } from "../../styles/styledButton";
import {
  StyledContentBlockResponse,
  StyledContentBlockResponseActionBts,
  StyledContentInfoResponse,
  StyledContentParentWrapperResponse
} from "./styledHowItWork";
import { StyledDecorationElementHomePage } from "../styledHomePage";
import { NavLink } from "react-router-dom";

const ContentParentResponse = () => {

  const [activeTab, setActiveTab] = useState("Design");

  const cardContentArray = [
    {
      type: "Registration",
      image: defaultCardImage,
      link: "/select-online-chat-service-provider",
      manualKey: "selectOnlineChatServiceProvider"
    },
    { type: "Design", image: defaultCardImage, link: "/add-online-chat-script", manualKey: "addOnlineChatScript" },
    {
      type: "Copy script",
      image: defaultCardImage,
      link: "/add-all-necessary-social-networks",
      manualKey: "addAllNecessarySocialNetworks"
    },
    {
      type: "Embed script",
      image: defaultCardImage,
      link: "/create-account-group-managers",
      manualKey: "createAccountGroupManagers"
    },
    {
      type: "Using app",
      image: defaultCardImage,
      link: "/contact-with-customers-profitable",
      manualKey: "contactWithCustomersProfitable"
    }
  ];

  return (
    <StyledContentParentWrapperResponse>
      <StyledContentInfoResponse>
        <StyledDecorationElementHomePage
          className="main-description"
          display="block"
          color="#646464"
          weight="300"
          size="14"
          lineHeight="16"
          mb="30"
        >
          Sed ut perspiciatis unde omnis iste
          natus error sit voluptatem accusantium
          doloremque laudantium, totam rem
          aperiam, eaque ipsa quae ab illo inventore
          veritatis et quasi architecto beatae vitae
          dicta sunt explicabo.
        </StyledDecorationElementHomePage>
      </StyledContentInfoResponse>

      {cardContentArray.map(({ type, image }) => {
        if (type === activeTab) {
          return (
            <StyledContentBlockResponse key={type}>
              <LazyLoadImage
                src={image ?? defaultCardImage}
                alt=""
                width={345}
                height={220}
                visibleByDefault={image ?? defaultCardImage}
              />
            </StyledContentBlockResponse>
          );
        }
      })}
      <StyledContentBlockResponseActionBts>
        {cardContentArray.map(({ type, link, manualKey }) => {
          return (
            <div key={type}>
              <StyledButton
                as={NavLink}
                to={{
                  pathname: link,
                  state: { manualKey }
                }}
                color="main"
                size="16"
                className="chat-image-btn"
                onClick={() => setActiveTab(type)}
              >
                {type}
              </StyledButton>
            </div>
          );
        })}
      </StyledContentBlockResponseActionBts>
      <StyledButton
        color="main"
        as={NavLink}
        to="/tariff-and-subscription"
        size="18"
        className="try-subscription-action"
      >
        Try a free subscription!
      </StyledButton>
    </StyledContentParentWrapperResponse>
  );
};

export default ContentParentResponse;